import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";

import { useHistory, useParams } from "react-router-dom";
import Header from "../../../components/Headers/Header";
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";
import { ArrowLeft, ArrowRight } from "react-bootstrap-icons";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import { ITopTen } from "../../../types";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import {
  getOverAllDistrictAndBlockTopTotalUsagesStudent,
  getOverAllDistrictTopTotalUsagesStudent,
  getOverAllTopTotalUsagesStudent,
} from "../../../Services/NewStats/StateOverViewAPIs";
import { useTopStudent } from "../Hooks/useTopStudent";
type IData = {
  employId: string;
  name: string;
  schoolName: string;
  schoolCode: string;
  district: string;
};

export default function TopStudent() {
  const param = useParams();
  const history = useHistory();
 
  const {
    isLoading,
    isFirst,
    setIsFirst,
    setParamsValue,
     getTopTenData,
     data
  } =useTopStudent()

  useEffect(() => {
    if (isFirst) {
      console.log("param type: ", param)
      setParamsValue(param)
      setIsFirst(false);
    } else {
      getTopTenData(param);
    }
  }, [isFirst]);
  

  return (
    <React.Fragment>
      <Header />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i> Top 10 Students
              </h3>
              <div>
                <div>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() =>
                      history.push(STATE_OFFICIAL_PATHS.stateOfficerDashboard)
                    }
                  >
                    <ArrowLeft /> Go Back
                  </Button>
                </div>
              </div>
            </div>
          </CardHeader>
          {isLoading ? (
            <div style={{ height: "300px" }}>
              <DotsSpinner />
            </div>
          ) :
          (
            <CardBody>
              {data?.length ? (
                <div className="d-flex flex-wrap">
                  {/* <i>First Week</i> */}
                  <Table className="w-100" responsive>
                    <tr>
                      <th className="px-2">Srn No.</th>
                      <th className="px-4">Name</th>
                      <th className="px-3">Grade</th>
                      {/* <th className="px-3">Section</th> */}
                      <th className="px-4"> School</th>
                      <th className="px-3">Block</th>
                      <th className="px-3">District</th>
                      <th className="px-2">
                        {param?.type?.trim() == "Total_time_tests"
                          ? "Time in Tests"
                          : param?.type.trim() == "avgStudentUsage"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_time_videos"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_Assignments"
                          ? "Total Assignments"
                          : param?.type.trim() == "Avg_Remedial"
                          ? "Avg_Remedial"
                          : param?.type.trim() == "Total_queries_raised"
                          ? "Total queries raised"
                          : param?.type.trim() == "Total_queries_solved"
                          ? "Total queries solved"
                          : ""}
                      </th>
                    </tr>
                    {data?.map((e) => (
                      <tr>
                        <td>{e?.student_srn}</td>
                        <td>{e?.student_name}</td>
                        <td>{e?.grade}</td>
                        {/* <td>{"gfghg"}</td> */}
                        <td>{e?.school}</td>
                        <td>{e?.block}</td>
                        <td>{e?.district}</td>
                        <td>
                          {param?.type.trim() == "Total_time_tests"
                            ? e?.Total_time_tests
                            : param?.type.trim() == "avgStudentUsage"
                            ? e?.total_usage
                            : param?.type.trim() == "Total_time_videos"
                            ? e?.Total_time_videos
                            : param?.type.trim() == "Total_Assignments"
                            ? e?.Total_Assignments
                            : param?.type.trim() == "Avg_Remedial"
                            ? e?.remedial
                            : param?.type.trim() == "Total_queries_raised"
                            ? e?.Total_queries_raised
                            : param?.type.trim() == "Total_queries_solved"
                            ? e?.Total_queries_solved
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </Table>
                </div>
              ) 
              : (
                <></>
              )}
              {/* {data?.second_week.length ? (
                <div className="d-flex flex-wrap">
                  <i>2nd Week</i>
                  <Table className="w-100" responsive>
                    <tr>
                      <th className="px-2">Srn No.</th>
                      <th className="px-4">Name</th>
                      <th className="px-3">Grade</th>
                      <th className="px-4"> School</th>
                      <th className="px-3">Block</th>
                      <th className="px-3">District</th>
                      <th className="px-2">
                        {" "}
                        {param?.type?.trim() == "Total_time_tests"
                          ? "Time in Tests"
                          : param?.type.trim() == "avgStudentUsage"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_time_videos"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_Assignments"
                          ? "Total Assignments"
                          : param?.type.trim() == "Avg_Remedial"
                          ? "Avg_Remedial"
                          : param?.type.trim() == "Total_queries_raised"
                          ? "Total queries raised"
                          : param?.type.trim() == "Total_queries_solved"
                          ? "Total queries solved"
                          : ""}
                      </th>
                    </tr>
                    {data?.second_week.map((e) => (
                      <tr>
                        <td>{e?.student_srn}</td>
                        <td>{e?.student_name}</td>
                        <td>{e?.grade}</td>
                        <td>{e?.school}</td>
                        <td>{e?.block}</td>
                        <td>{e?.district}</td>
                        <td>
                          {param?.type.trim() == "Total_time_tests"
                            ? e?.Total_time_tests
                            : param?.type.trim() == "avgStudentUsage"
                            ? e?.total_usage
                            : param?.type.trim() == "Total_time_videos"
                            ? e?.Total_time_videos
                            : param?.type.trim() == "Total_Assignments"
                            ? e?.Total_Assignments
                            : param?.type.trim() == "Avg_Remedial"
                            ? e?.remedial
                            : param?.type.trim() == "Total_queries_raised"
                            ? e?.Total_queries_raised
                            : param?.type.trim() == "Total_queries_solved"
                            ? e?.Total_queries_solved
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </Table>
                </div>
              ) : (
                <></>
              )} */}
              {/* {data?.third_week.length ? (
                <div className="d-flex flex-wrap">
                  <i>3rd Week</i>
                  <Table className="w-100" responsive>
                    <tr>
                      <th className="px-2">Srn No.</th>
                      <th className="px-4">Name</th>
                      <th className="px-3">Grade</th>
                      <th className="px-4"> School</th>
                      <th className="px-3">Block</th>
                      <th className="px-3">District</th>
                      <th className="px-2">
                        {" "}
                        {param?.type?.trim() == "Total_time_tests"
                          ? "Time in Tests"
                          : param?.type.trim() == "avgStudentUsage"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_time_videos"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_Assignments"
                          ? "Total Assignments"
                          : param?.type.trim() == "Avg_Remedial"
                          ? "Avg_Remedial"
                          : param?.type.trim() == "Total_queries_raised"
                          ? "Total queries raised"
                          : param?.type.trim() == "Total_queries_solved"
                          ? "Total queries solved"
                          : ""}
                      </th>
                    </tr>
                    {data?.third_week.map((e) => (
                      <tr>
                        <td>{e?.student_srn}</td>
                        <td>{e?.student_name}</td>
                        <td>{e?.grade}</td>
                        <td>{e?.school}</td>
                        <td>{e?.block}</td>
                        <td>{e?.district}</td>
                        <td>
                          {param?.type.trim() == "Total_time_tests"
                            ? e?.Total_time_tests
                            : param?.type.trim() == "avgStudentUsage"
                            ? e?.total_usage
                            : param?.type.trim() == "Total_time_videos"
                            ? e?.Total_time_videos
                            : param?.type.trim() == "Total_Assignments"
                            ? e?.Total_Assignments
                            : param?.type.trim() == "Avg_Remedial"
                            ? e?.remedial
                            : param?.type.trim() == "Total_queries_raised"
                            ? e?.Total_queries_raised
                            : param?.type.trim() == "Total_queries_solved"
                            ? e?.Total_queries_solved
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </Table>
                </div>
              ) : (
                <></>
              )} */}
              {/* {data?.fourth_week.length ? (
                <div className="d-flex flex-wrap">
                  <i className="align-self-center">4th Week</i>
                  <Table className="w-100" responsive>
                    <tr>
                      <th className="px-2">Srn No.</th>
                      <th className="px-4">Name</th>
                      <th className="px-3">Grade</th>
                      <th className="px-4"> School</th>
                      <th className="px-3">Block</th>
                      <th className="px-3">District</th>
                      <th className="px-2">
                        {" "}
                        {param?.type?.trim() == "Total_time_tests"
                          ? "Time in Tests"
                          : param?.type.trim() == "avgStudentUsage"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_time_videos"
                          ? "Total Usage (in mins)"
                          : param?.type.trim() == "Total_Assignments"
                          ? "Total Assignments"
                          : param?.type.trim() == "Avg_Remedial"
                          ? "Avg_Remedial"
                          : param?.type.trim() == "Total_queries_raised"
                          ? "Total queries raised"
                          : param?.type.trim() == "Total_queries_solved"
                          ? "Total queries solved"
                          : ""}
                      </th>
                    </tr> */}
                    {/* {data?.fourth_week.map((e) => (
                      <tr>
                        <td>{e?.student_srn}</td>
                        <td>{e?.student_name}</td>
                        <td>{e?.grade}</td>
                        <td>{e?.school}</td>
                        <td>{e?.block}</td>
                        <td>{e?.district}</td>
                        <td>
                          {param?.type.trim() == "Total_time_tests"
                            ? e?.Total_time_tests
                            : param?.type.trim() == "avgStudentUsage"
                            ? e?.total_usage
                            : param?.type.trim() == "Total_time_videos"
                            ? e?.Total_time_videos
                            : param?.type.trim() == "Total_Assignments"
                            ? e?.Total_Assignments
                            : param?.type.trim() == "Avg_Remedial"
                            ? e?.remedial
                            : param?.type.trim() == "Total_queries_raised"
                            ? e?.Total_queries_raised
                            : param?.type.trim() == "Total_queries_solved"
                            ? e?.Total_queries_solved
                            : ""}
                        </td>
                      </tr>
                    ))} 
                    
                  </Table>
                </div>
              ) : (
                <></>
              )} */}
            </CardBody>
          )}
        </Card>
      </Container>
    </React.Fragment>
  );
}
